import pulse, { TrackerData } from "@finn-no/pulse-sdk";

export const trackPageView = () => {
	const pulsePayload: TrackerData = {
		type: "View",
		name: "Content-module-insertion",
		object: {
			type: "Form",
			pageType: "content-insertion",
		},
		vertical: {
			name: "mobility",
		},
	};
	pulse.trackPageView(pulsePayload);
};
